<div class="sg-slider-container" [class.sg-slider-disabled]="disabled">
  <mat-slider #matSlider class="sg-slider" [min]="min" [max]="max" [step]="step" [disabled]="disabled" [displayWith]="formatLabel" [discrete]="showTooltip">
    <input matSliderThumb [value]="value" (valueChange)="onSliderChange($event)" (input)="onSliderInput($event)" />
  </mat-slider>
</div>
